import { initBookingPhone } from './init-booking-phone.js';

const sectionSelector = '.booking-section';
const tabSelector = '.booking-section__tab';
const contentSelector = '[data-booking-content]';

const activeTabClassName = 'booking-section__tab--active';
const activeContentClassName = 'booking-section__content--active';
const contentChangeDelay = 350;

function setActiveTab(tabs, activeTabName) {
    tabs.forEach((tab) => {
        const isActive = tab.dataset.bookingTab === activeTabName;

        tab.classList.toggle(activeTabClassName, isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
}

function hideContents(contents) {
    contents.forEach((content) => {
        content.classList.remove(activeContentClassName);
    });
}

function showContent(contents, activeTabName) {
    contents
        .find((content) => content.dataset.bookingContent === activeTabName)
        ?.classList.add(activeContentClassName);
}

export function initBookingSection() {
    const sections = document.querySelectorAll(sectionSelector);

    if (!sections.length) {
        return;
    }

    sections.forEach((section) => {
        const tabs = Array.from(section.querySelectorAll(tabSelector));
        const contents = Array.from(section.querySelectorAll(contentSelector));

        if (!tabs.length || !contents.length) {
            return;
        }

        const activeTab = tabs.find((tab) => tab.classList.contains(activeTabClassName)) || tabs[0];
        let contentChangeTimer = null;
        const selectPhone = initBookingPhone(section);

        if (activeTab) {
            setActiveTab(tabs, activeTab.dataset.bookingTab);
            showContent(contents, activeTab.dataset.bookingTab);
            selectPhone(activeTab.dataset.bookingTab);
        }

        tabs.forEach((tab) => {
            tab.addEventListener('click', () => {
                if (tab.classList.contains(activeTabClassName)) {
                    return;
                }

                const tabName = tab.dataset.bookingTab;
                const content = contents.find((item) => item.dataset.bookingContent === tabName);

                if (!content) {
                    return;
                }

                window.clearTimeout(contentChangeTimer);

                setActiveTab(tabs, tabName);
                selectPhone(tabName);
                hideContents(contents);

                contentChangeTimer = window.setTimeout(() => {
                    content.classList.add(activeContentClassName);
                }, contentChangeDelay);
            });
        });
    });
}
